<template>
	<li :class="{[styles.air__menuTop__item]: true,[styles.air__menuTop__item__active]: item.key === activeItem,}">
		<router-link v-if="item.url" :to="item.url" :class="styles.air__menuTop__link">
			<fa-icon v-if="item.icon" :icon="item.icon" :class="{[item.icon]: true,[styles.air__menuTop__icon]: true,}" />
			<a-badge v-if="item.badge" :count="$store.getters['flags/'+item.badge]" :offset="[18,0]">
				<span>{{ item.title }}</span>
			</a-badge>
			<span v-else>{{ item.title }}</span>
		</router-link>
		<a v-else-if="item.event" href="javascript: void(0);" :class="styles.air__menuTop__link" @click="$hub.emit(item.event)">
			<fa-icon v-if="item.icon" :icon="item.icon" :class="{[item.icon]: true,[styles.air__menuTop__icon]: true,}" />
			<a-badge v-if="item.badge" :count="$store.getters['flags/'+item.badge]" :offset="[18,0]" :number-style="{'box-shadow': 'none'} ">
				<span>{{ item.title }}</span>
			</a-badge>
			<span v-else>{{ item.title }}</span>
		</a>
		<a v-else-if="!item.url && !item.event" href="javascript: void(0);" :class="styles.air__menuTop__link">
			<fa-icon v-if="item.icon" :icon="item.icon" :class="{[item.icon]: true,[styles.air__menuTop__icon]: true,}" />
			<a-badge v-if="item.badge" :count="$store.getters['flags/'+item.badge]" :offset="[18,0]">
				<span>{{ item.title }}</span>
			</a-badge>
			<span v-else>{{ item.title }}</span>
		</a>
	</li>
</template>

<script>
/* eslint-disable vue/require-default-prop */

export default {
	name: 'Item',
	props: {
		item: Object,
		styles: Object,
		activeItem: String,
	},
};
</script>
